import { createWrapper } from '../../fhir-react/base';

export const CoverageWrapper = createWrapper('Coverage', () => ({}));
export type WrappedCoverage = ReturnType<typeof CoverageWrapper>;